<template>
<div>
  <Nav :navTitle="navTitle" :leftText="leftText" :rightText="rightText" :leftArrow="leftArrow" />
  <div class="content detailBox">
    <van-cell-group inset>
      <van-cell title="姓名" :value="detail.name" :title-class="titleClass" :value-class="valueClass"/>
      <van-cell title="联系电话" :value="detail.telphone" :title-class="titleClass" :value-class="valueClass"/>
      <van-cell title="准驾车型" :value="detail.zjcx" :title-class="titleClass" :value-class="valueClass"/>
      <van-cell title="身份证" :value="detail.shenfenzheng" :title-class="titleClass" :value-class="valueClass"/>

      <div v-if="detail.jiashizhengurl">
        <van-cell title="本人驾驶证正页" :title-class="titleClass"/>
        <div class="imageBox">
<van-image :src="detail.jiashizhengurl" />
        </div>
      </div>

      <div v-if="detail.jieshizhengfburl">
        <van-cell title="本人驾驶证副页" :title-class="titleClass"/>
        <div class="imageBox">
          <van-image :src="detail.jieshizhengfburl" />
        </div>
      </div>

      <van-cell title="驾驶证截至日期" :value="detail.jiashizhengyxq" :title-class="titleClass" :value-class="valueClass"/>

      <div v-if="detail.congyezigeurl">
        <van-cell title="从业资格证正面" :title-class="titleClass"/>
        <div class="imageBox">
          <van-image :src="detail.congyezigeurl" />
        </div>
      </div>

      <div v-if="detail.congyezigefmurl">
        <van-cell title="从业资格证反面" :title-class="titleClass"/>
        <div class="imageBox">
          <van-image :src="detail.congyezigefmurl" />
        </div>
      </div>

      <van-cell title="从业资格证截至日期" :value="detail.congyezigeyxq" :title-class="titleClass" :value-class="valueClass"/>
    </van-cell-group>

  </div>

</div>
</template>

<script>
import api from '@/fetch/api'
import Nav from "../Public/navTpl.vue"
import {
  Toast
} from 'vant';

export default {
  components: {
    Nav,
  },
  data() {
    return {
      navTitle: document.title,
      leftText: "返回",
      rightText: "首页",
      leftArrow: false,
      id: "",
      detail: [],
      titleClass:"title-class-hq",
      valueClass:"value-class-hq",
    }
  },
  created() {
    document.title = "驾驶员详情";
    var id = this.$route.params.id;
    this.$data.id = id;
    this.getDriverBeianDetail(id);
  },
  methods: {
    getDriverBeianDetail(id) {
      var that = this;
      var weburl = that.GLOBAL.weburl;
      api.getDriverBeianDetail(id).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          var detail = res.data;
          detail.jiashizhengurl = detail.jiashizhengurl ? weburl + '/' + detail.jiashizhengurl : "";
          detail.jieshizhengfburl = detail.jieshizhengfburl ? weburl + '/' + detail.jieshizhengfburl : "";
          detail.congyezigeurl = detail.congyezigeurl ? weburl + '/' + detail.congyezigeurl : "";
          detail.congyezigefmurl = detail.congyezigefmurl ? weburl + '/' + detail.congyezigefmurl : "";
          that.$data.detail = detail;

        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');
      });
    },
  }
}
</script>

<style lang="scss" scoped>
html{
  background: #fff;
}
.content {
    margin-top: 4.75rem;
    padding-bottom: 1rem;
    .imageBox{
      border:2px solid #ececec;
    }
}
</style>
